import { Power } from "lucide-react";
import { toast } from "sonner";
import { useAdminContent } from "@/context/AdminContentContext";
import { Field, Panel, TextArea, TextInput } from "@/components/admin/Field";
import { Switch } from "@/components/ui/switch";

export default function EditManutencao() {
  const { draft, update, save } = useAdminContent();
  const m = draft.maintenance || {};
  const set = (k) => (v) => update("maintenance", { [k]: v });

  const toggle = async (on) => {
    const next = { ...draft, maintenance: { ...m, enabled: on } };
    const ok = await save(true, next);
    if (ok) toast.success(on ? "Modo manutenção ATIVADO. Os visitantes já veem a página de manutenção." : "Modo manutenção desativado. O site está de novo visível.");
  };

  return (
    <>
      <Panel title="Modo manutenção" description="Com um clique, todo o site público passa a mostrar uma página de manutenção com contador. Enquanto tiveres sessão iniciada continuas a ver o site normal (com um aviso amarelo).">
        <div className={`flex items-center justify-between gap-4 rounded-md border p-5 ${m.enabled ? "border-amber-500/60 bg-amber-500/10" : "border-eden-border bg-eden-bg"}`} data-testid="maintenance-toggle-card">
          <div className="flex items-center gap-4">
            <span className={`grid h-11 w-11 place-items-center rounded-full ${m.enabled ? "bg-amber-500 text-eden-bg" : "bg-eden-surface text-eden-muted"}`}><Power size={20} /></span>
            <div>
              <p className="font-display text-base font-semibold text-eden-text" data-testid="maintenance-state">{m.enabled ? "Manutenção ativa" : "Site online para todos"}</p>
              <p className="text-xs text-eden-muted">{m.enabled ? "Os visitantes veem apenas a página de manutenção." : "Liga para esconder o site aos visitantes."}</p>
            </div>
          </div>
          <Switch checked={!!m.enabled} onCheckedChange={toggle} aria-label="Ativar modo manutenção" data-testid="maintenance-switch" />
        </div>
      </Panel>
      <Panel title="Conteúdo da página de manutenção" description="Guarda para aplicar as alterações de texto.">
        <Field label="Etiqueta" id="maint-eyebrow"><TextInput id="maint-eyebrow" value={m.eyebrow || ""} onChange={set("eyebrow")} maxLength={60} placeholder="Em manutenção" /></Field>
        <Field label="Título" id="maint-title"><TextInput id="maint-title" value={m.title || ""} onChange={set("title")} maxLength={160} /></Field>
        <Field label="Texto" id="maint-text"><TextArea id="maint-text" value={m.text || ""} onChange={set("text")} rows={3} maxLength={600} /></Field>
        <div className="grid gap-4 sm:grid-cols-2">
          <Field label="Voltamos em (data e hora)" id="maint-until" hint="Deixa vazio para não mostrar contador."><TextInput id="maint-until" type="datetime-local" value={m.until || ""} onChange={set("until")} /></Field>
          <Field label="Título do contador" id="maint-cd-title"><TextInput id="maint-cd-title" value={m.countdown_title || ""} onChange={set("countdown_title")} maxLength={80} placeholder="Voltamos em" /></Field>
        </div>
        <Field label="Texto quando o contador termina" id="maint-cd-done"><TextInput id="maint-cd-done" value={m.countdown_done_text || ""} onChange={set("countdown_done_text")} maxLength={120} placeholder="Estamos quase de volta." /></Field>
        <label className="flex items-center gap-3 text-sm text-eden-text" htmlFor="maint-discord">
          <input id="maint-discord" type="checkbox" className="h-4 w-4 accent-eden-orange" checked={m.show_discord !== false} onChange={(e) => set("show_discord")(e.target.checked)} data-testid="maintenance-show-discord" />
          Mostrar botão para o Discord
        </label>
        <Field label="Texto do botão Discord" id="maint-discord-label"><TextInput id="maint-discord-label" value={m.discord_label || ""} onChange={set("discord_label")} maxLength={40} placeholder="Acompanha no Discord" /></Field>
      </Panel>
    </>
  );
}
